import React from 'react';
import enhanceWithClickOutside from "react-click-outside";
class LocationPicker extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false
        };
    }
    toggle() {
        this.setState({ open: !this.state.open });
    }

    handleClickOutside() {
        if (this.state.open) {
            this.toggle();
        }
    }

    renderTree(root) {
        var self = this;
        if (!root) {
            return null
        }
        /*  for (var i = 0; i < root.children.length; i++) {
              if (root.children[i].type == "sensor") {
                  return null;
              }
          }*/
        return (
            <div className="location-picker-dropdown" key={root.id}>
                {
                    root.type != "customer" ?
                        <label>
                            <input
                                type="checkbox"
                                disabled={this.props.disabled}
                                checked={root.info.cardid == this.props.card.id}
                                onChange={() => this.props.handleChange(root, this.props.card)}
                            />
                            <span className={this.props.disabled ? "disabled" : ""}>{root.info.name}</span>
                        </label>
                        : null
                }
                {
                    root.children.map((x) => {
                        if (x.type != "sensor") {
                            return self.renderTree(x);
                        } else {
                            return null;
                        }
                    })
                }
            </div>
        );
    }

    render() {
        return (
            <div className="pull-right location-picker">
                <a type="button" className="" onClick={this.toggle.bind(this)}>Locations </a>
                <i className="fa fa-chevron-down" aria-hidden="true"></i>
                <div className={"dropdown-menu " + (this.state.open ? "" : "hidden")}
                    style={{
                        maxHeight: 300,
                        minWidth: 370,
                        overflow: "auto",
                        zIndex: 1001// display in front of TimeInterval & OccupancyThreshold
                    }}
                    aria-labelledby="loc-picker">
                    {this.renderTree(this.props.root)}
                </div>
            </div >
        );
    }
}

export default enhanceWithClickOutside(LocationPicker);


// WEBPACK FOOTER //
// ./src/components/pages/defaultsettings/LocationPicker.jsx